import React, { useEffect, useMemo, useState } from 'react';
import { buildUploadImageCandidates } from '../utils/cleroFotos';

/**
 * Imagen de perfil con respaldo /api/uploads → /uploads → proxy media.
 */
const ProfileImage = ({ src, alt, className = '', fallbackSrc = null }) => {
  const candidates = useMemo(() => {
    if (!src) return [];
    const built = buildUploadImageCandidates(src);
    return built.length > 0 ? built : [];
  }, [src]);

  const [attempt, setAttempt] = useState(0);

  useEffect(() => {
    setAttempt(0);
  }, [src]);

  if (!src || candidates.length === 0) {
    if (!fallbackSrc) return null;
    return <img src={fallbackSrc} alt={alt || ''} className={className} loading="lazy" decoding="async" />;
  }

  if (attempt >= candidates.length) {
    if (!fallbackSrc) return null;
    return <img src={fallbackSrc} alt={alt || ''} className={className} loading="lazy" decoding="async" />;
  }

  return (
    <img
      src={candidates[attempt]}
      alt={alt || ''}
      className={className}
      loading="lazy"
      decoding="async"
      onError={() => setAttempt((a) => a + 1)}
    />
  );
};

export default ProfileImage;
